import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

export const calculateTotalCashToClose = (loan: any, form: FormInstance) => {
  const closingCostTimelineActive = form.getFieldValue(['reportView', 'closingCostsEstimates', 'active']);
  const downPaymentActive = form.getFieldValue(['tableView', 'downPayment', 'active']);
  const downPayment = parseFloat(loan?.downPayment?.value) || 0;
  const closingCosts = parseFloat(loan?.closingCosts?.value) || 0;
  const depositMoneyPrice = parseFloat(loan?.deposit_money_price) || 0;
  const addClosingCosts = loan?.externalLoan?.addClosingCosts;
  const closingCostsClearedAt = loan?.externalLoan?.closingCostsClearedAt;

  const total = Math.max(
    (
      (downPaymentActive ? downPayment : 0) + (addClosingCosts || closingCostsClearedAt ? 0 : closingCosts)) -
    (closingCostTimelineActive ? depositMoneyPrice : 0),
    0
  );

  return parseFloat(formatAmount(total));
}
